import { RequestQuoteDialog } from "../RequestQuoteDialog/RequestQuoteDialog";

import { JSX, useState } from "react";
import { useTranslation } from "react-i18next";

import MailOutlineOutlinedIcon from "@mui/icons-material/MailOutlineOutlined";
import { Button } from "@mui/material";
import { useSessionId } from "@plansoft-configuration-renderer/framework";

export function RequestQuoteButton({
  disabled,
}: {
  disabled?: boolean;
}): JSX.Element {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const sessionId = useSessionId();

  return (
    <>
      {open && (
        <RequestQuoteDialog
          handleClose={() => setOpen(false)}
          sessionId={sessionId}
        />
      )}

      <Button
        variant="contained"
        startIcon={<MailOutlineOutlinedIcon />}
        onClick={() => setOpen(true)}
        disabled={disabled}
      >
        {t("AS:footer.button.requestQuote")}
      </Button>
    </>
  );
}
